// extracted by mini-css-extract-plugin
module.exports = {"wrpr":"QuickLinks_wrpr__j_JxF","linksCont":"QuickLinks_linksCont__R_18a"};